import { BaseModel } from "../abstracts/base.model";
import { DocumentModel } from './document.model';
import { ExamAnswerListModel } from './exam-answer-list.model';

export class ExamBookletModel extends BaseModel {
    ExamBookletID: number
    ExamID: number
    ExamBookletIndex: number
    DocumentID: string;
    ExamAnswerLists: ExamAnswerListModel[];

    file: File;
    document: DocumentModel;
}